module.exports = __webpack_public_path__ + "static/media/2.2402dc52.svg";